import {observable} from 'mobx';
import {Language} from './language';
import {OfferAsset} from './offer-asset';
import {OfferProduct} from './offer-product';
import {OfferLocaleContent} from './offer-locale-content';
import {construct, createArrayInstance, createInstance, ModelProperties} from '../utils';

export class OfferPage {
    @observable id!: number;

    @observable route!: string;

    @observable enabled!: boolean;

    @observable published!: boolean;

    @observable outdated!: boolean;

    @observable isAffiliated!: boolean;

    @observable redirect!: boolean;

    @observable redirectRoute!: string;


    @observable redirectTimer!: boolean;

    @observable redirectRouteTimer!: string;

    @observable tag!: string;

    @observable timerDate!: string;

    @observable timerTime!: string;

    @observable timerTimezone!: string;

    @observable timerMode!: number;

    @observable defaultLanguageId!: number;

    @observable titleId?: number | null;

    @observable backgroundId?: number | null;

    @observable backgroundTabletId?: number | null;

    @observable backgroundMobileId?: number | null;

    @observable illustrationId?: number | null;

    @observable affiliateId?: number | null;

    @observable categoryId?: number | null | undefined;

    @observable defaultLanguage?: Language;

    @observable content?: OfferLocaleContent[];

    @observable products?: OfferProduct[];

    @observable background?: OfferAsset;
    
    @observable title?: OfferAsset;

    @observable backgroundTablet?: OfferAsset;

    @observable backgroundMobile?: OfferAsset;

    @observable illustration?: OfferAsset;

    @observable affiliate?: OfferAsset;

    @observable disableStickyBanner!: boolean;

    @observable logo!: number;

    @observable enabledCustomHeaderTitleColor!: boolean;

    @observable enabledCustomHeaderSubtitleColor!: boolean;

    @observable enabledCustomTimerTitleColor!: boolean;

    @observable enabledCustomTimerBackgroundColor!: boolean;

    @observable enabledCustomTimerNumbersColor!: boolean;

    @observable enabledCustomFlagsTextColor!: boolean;

    @observable enabledCustomAffiliateTextColor!: boolean;

    @observable enabledCustomLogoColor!: boolean;

    @observable enabledCustomHighlightColor!: boolean;

    @observable enabledCustomHighlightTextColor!: boolean;

    @observable enabledCustomSubscriptionCardHeaderTextColor!: boolean;

    @observable enabledCustomButtonTextColor!: boolean;

    @observable enabledCustomButtonColor!: boolean;

    @observable enabledCustomHeroOrder!: boolean;

    @observable enabledCustomFont!: boolean;

    @observable customHeaderTitleColor!: string;

    @observable customHeaderSubtitleColor!: string;

    @observable customTimerTitleColor!: string;

    @observable customTimerBackgroundColor!: string;

    @observable customTimerNumbersColor!: string;

    @observable customFlagsTextColor!: string;

    @observable customAffiliateTextColor!: string;

    @observable customLogoColor!: string;

    @observable customHighlightColor!: string;

    @observable customHighlightTextColor!: string;

    @observable customButtonTextColor!: string;

    @observable customButtonColor!: string;

    @observable customSubscriptionCardHeaderTextColor!: string;

    @observable customFont!: string;
    
    @observable stickyInstallEnabled!: boolean;

    @observable stickyInstallLink!: string;

    @observable stickyInstallButtonText!: string;
    
    @observable stickyInstallLogoText!: string;

    @observable enabledCustomMostPopularTheme!: boolean;

    @observable enabledCustomBackground!: boolean;

    @observable customMostPopularTheme!: string;

    @observable customBackground!: string;

    @observable customHeroOrder!: string;



    constructor(page?: ModelProperties<OfferPage>) {
        if (page) {
            construct(this, page);
            this.content = createArrayInstance(OfferLocaleContent, page.content);
            this.products = createArrayInstance(OfferProduct, page.products);
            this.background = createInstance(OfferAsset, page.background);
            this.defaultLanguage = createInstance(Language, page.defaultLanguage);
            this.backgroundMobile = createInstance(OfferAsset, page.backgroundMobile);
            this.backgroundTablet = createInstance(OfferAsset, page.backgroundTablet);
            this.illustration = createInstance(OfferAsset, page.illustration);
            this.affiliate = createInstance(OfferAsset, page.affiliate);
        }
    }
}